/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EvmBlockDetailInfo } from '../models/EvmBlockDetailInfo';
import type { EvmBlockListInfo } from '../models/EvmBlockListInfo';
import type { EvmBlockSummaryInfo } from '../models/EvmBlockSummaryInfo';
import type { EvmInternalTrxGroupInfo } from '../models/EvmInternalTrxGroupInfo';
import type { EvmTrxListInfo } from '../models/EvmTrxListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EvmBlockControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns EvmTrxListInfo OK
     * @throws ApiError
     */
    public getEvmTransactionListByBlockNumber({
        blockNumber,
        page = 1,
        size = 25,
    }: {
        blockNumber: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTrxListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/block/transaction/list',
            query: {
                'blockNumber': blockNumber,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTrxListInfo OK
     * @throws ApiError
     */
    public getEvmTransactionListByBlockNumber1({
        blockNumber,
        page = 1,
        size = 25,
    }: {
        blockNumber: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTrxListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/block/transaction/list',
            query: {
                'blockNumber': blockNumber,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmInternalTrxGroupInfo OK
     * @throws ApiError
     */
    public getEvmInternalTrxListByBlockNumber({
        blockNumber,
        page = 1,
        size = 15,
    }: {
        blockNumber: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmInternalTrxGroupInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/block/transaction/internal/list',
            query: {
                'blockNumber': blockNumber,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmInternalTrxGroupInfo OK
     * @throws ApiError
     */
    public getEvmInternalTrxListByBlockNumber1({
        blockNumber,
        page = 1,
        size = 15,
    }: {
        blockNumber: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmInternalTrxGroupInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/block/transaction/internal/list',
            query: {
                'blockNumber': blockNumber,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmBlockSummaryInfo OK
     * @throws ApiError
     */
    public getEvmBlockSummaryList({
        size = 10,
    }: {
        size?: number,
    }): CancelablePromise<Array<EvmBlockSummaryInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/block/summary',
            query: {
                'size': size,
            },
        });
    }

    /**
     * @returns EvmBlockSummaryInfo OK
     * @throws ApiError
     */
    public getEvmBlockSummaryList1({
        size = 10,
    }: {
        size?: number,
    }): CancelablePromise<Array<EvmBlockSummaryInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/block/summary',
            query: {
                'size': size,
            },
        });
    }

    /**
     * @returns EvmBlockListInfo OK
     * @throws ApiError
     */
    public getEvmBlockList({
        page = 1,
        size = 25,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<EvmBlockListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/block/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmBlockListInfo OK
     * @throws ApiError
     */
    public getEvmBlockList1({
        page = 1,
        size = 25,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<EvmBlockListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/block/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmBlockDetailInfo OK
     * @throws ApiError
     */
    public getEvmBlockDetail({
        blockNumber,
    }: {
        blockNumber: string,
    }): CancelablePromise<EvmBlockDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/block',
            query: {
                'blockNumber': blockNumber,
            },
        });
    }

    /**
     * @returns EvmBlockDetailInfo OK
     * @throws ApiError
     */
    public getEvmBlockDetail1({
        blockNumber,
    }: {
        blockNumber: string,
    }): CancelablePromise<EvmBlockDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/block',
            query: {
                'blockNumber': blockNumber,
            },
        });
    }

}
